/**
 * Business Brand Plane Bridge — L1 identity context for shell chrome
 * @see docs/inflomatrix-constitution/ui-architecture/BRAND_PLANE_BRIDGE.md
 */

import { createContext, useContext } from 'react';
import type { BrandIdentity } from '@shared/site/design/brand-identity';

export interface BusinessBrandContextValue {
  brand: BrandIdentity | undefined;
  /** True after published-only fetch settles (success or constitutional fallback). */
  ready: boolean;
}

const defaultValue: BusinessBrandContextValue = {
  brand: undefined,
  ready: false,
};

export const BusinessBrandContext = createContext<BusinessBrandContextValue>(defaultValue);

export function useBusinessBrand(): BusinessBrandContextValue {
  return useContext(BusinessBrandContext);
}
